import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';
import LoginBackground from './components/LoginBackground';
import { supabase, isSupabaseConfigured } from 'lib/supabase';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const checkExistingSession = async () => {
      if (isSupabaseConfigured() && supabase) {
        try {
          const { data } = await supabase.auth.getSession();
          if (!cancelled && data?.session) {
            navigate('/dashboard');
            return;
          }
        } catch {
          // Fall through to the localStorage check.
        }
      }

      const userSession = localStorage.getItem('userSession');
      if (userSession) {
        try {
          const session = JSON.parse(userSession);
          if (session?.email && session?.role) {
            navigate('/dashboard');
          }
        } catch {
          localStorage.removeItem('userSession');
        }
      }
    };

    checkExistingSession();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left Side - Login Form */}
      <div className="flex-1 lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <LoginHeader />
          <LoginForm />
          <LoginFooter />
        </div>
      </div>

      {/* Right Side - Background Image & Content */}
      <LoginBackground />
    </div>
  );
};

export default Login;
